export default {
    'NeueHaasGroteskNormal': {
        fontFamily: '"NeueHaasGrotesk", "HelveticaNeue", Helvetica, Arial, Verdana, sans-serif',
        fontWeight: 400,
        fontStyle: 'normal',
    },
    'NeueHaasGroteskBold': {
        fontFamily: '"NHaasGroteskTXPro-65Md", "HelveticaNeue", Helvetica, Arial, Verdana, sans-serif',
        fontWeight: 700,
        fontStyle: 'normal',
    },
    'NeueHaasGroteskNormalItalic': {
        fontFamily: '"NeueHaasGrotesk", "HelveticaNeue", Helvetica, Arial, Verdana, sans-serif',
        fontWeight: 400,
        fontStyle: 'italic',
    },
    'NeueHaasGroteskBoldItalic': {
        fontFamily: '"NeueHaasGrotesk", "HelveticaNeue", Helvetica, Arial, Verdana, sans-serif',
        fontWeight: 700,
        fontStyle: 'italic',
    },
};


// WEBPACK FOOTER //
// ./src/constants/fonts.ts